import { useParams } from "react-router";

import useMetricsQuery from "@app/analytics/hooks/metrics/useMetricsQuery";
import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";
import { getDateRange } from "@app/analytics/MeetingReport/utils";
import { MeetOpsQuery } from "@app/analytics/meetops/types";
import useAuth from "@app/common/auth/useAuth";

interface QueryOpts {
  queryKey: (string | number | undefined | null)[];
  enabled?: boolean;
}

const useMeetingReportMetricsQuery = (
  {
    metrics = [],
    filters = [],
    dimensions = [],
    people = "everyone",
  }: Partial<MeetOpsQuery>,
  { queryKey, enabled = true }: QueryOpts
) => {
  const { sessionId } = useParams();
  const { user } = useAuth();
  const { meetingReport, isLoading } = useMeetingReport({ enabled });

  const dateRanges = getDateRange(meetingReport?.rawStartTime);

  return useMetricsQuery(
    {
      dateRanges,
      userId: user?.id,
      metrics,
      filters,
      dimensions,
      people,
      sessionId,
    },
    {
      enabled: !isLoading && enabled,
      queryKey: [sessionId, user?.id, queryKey],
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
};

export default useMeetingReportMetricsQuery;
